import styled from "styled-components";

const Wrap = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	display: flex;
	gap: 8px;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	text-align: center;
	align-items: center;
	justify-content: center;
`;

const Text = styled.p`
	font-size: 14px;
	color: #fff;
	line-height: 1.7;
`;
const DeselectButton = styled.button`
	height: 38px;
	padding: 0 30px;
	border: 1px solid #fff;
	background-color: transparent;
	color: #fff;
	line-height: 1.5;
`;

const CompareButton = styled.button`
	height: 38px;
	padding: 0 30px;
	border: none;
	background-color: var(--emp-color);
	color: #fff;
	line-height: 1.5;
`;

const CompareTextBox = () => (
	<Wrap>
		<Text>
			비교할 상품을 선택해주세요.
			<br /> 총 3개까지 선택하여
			<br /> 비교하실 수 있습니다.
		</Text>
	</Wrap>
);

const CompareButtonBox = ({compare, clear}) => (
	<Wrap>
		<DeselectButton type="button" {...clear}>
			선택 해제
		</DeselectButton>
		<CompareButton type="button" {...compare}>
			상품 비교
		</CompareButton>
	</Wrap>
);

export {CompareTextBox, CompareButtonBox};
